export const nucleusSymbolMap = {
    proton: '1H',
    hydrogen: 'H',
    helium: 'He',
    lithium: 'Li',
    carbon: 'C',
    nitrogen: 'N',
    oxigen: 'O',
    fluorine: 'F',
    sodium: 'Na',
    aluminum: 'Al',
    silicon: 'Si',
    phosphorus: 'P',
    iron: 'Fe',
    copper: 'Cu',
    zinc: 'Zn',
    xenon: 'Xe',
};
//# sourceMappingURL=nucleusMap.js.map